import { RegionShared } from "@1games-ru/region-shared";
import { useEffect } from "react";
import rpc from "@1games-ru/rage-rpc";
import useGetPlayer from "@/shared/hooks/useGetPlayer";

export default function useUpdatePlayerInfo() {
  const { getPlayer } = useGetPlayer();

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Character.UpdatePlayerInfo, getPlayer);

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Character.UpdatePlayerInfo);
    };
  }, []);
}
